import { Box, Paper, Skeleton } from '@mui/material'
import { memo } from 'react'

export interface MrtMobileCardSkeletonProps {
  /**
   * Número de campos que se simulan en el cuerpo.
   * Default: 4.
   */
  fields?: number
  /**
   * Número de columnas del cuerpo.
   * Default: 2.
   */
  columns?: number
}

/**
 * Skeleton de una tarjeta de tipo mobile.
 *
 * @param param0
 * @param param0.fields
 * @param param0.columns
 * @constructor
 * @author isi-template
 */
function MrtMobileCardSkeletonComponent({ fields = 4, columns = 2 }: MrtMobileCardSkeletonProps) {
  const safeFields = Math.max(1, fields)
  return (
    <Paper
      variant="outlined"
      sx={{
        width: '100%',
        overflow: 'hidden',
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          px: 1.25,
          py: 0.65,
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        {/* Checkbox / radio */}
        <Skeleton variant="circular" width={24} height={24} />
        {/* Title */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
          }}
        >
          <Skeleton variant="text" width="65%" height={20} />
          <Skeleton variant="text" width="35%" height={16} />
        </Box>
        {/* Actions */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.25,
          }}
        >
          <Skeleton variant="circular" width={28} height={28} />
          <Skeleton variant="circular" width={28} height={28} />
          <Skeleton variant="circular" width={28} height={28} />
        </Box>
      </Box>
      <Box
        sx={{
          px: 1.5,
          py: 1.1,
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
          columnGap: 1.5,
          rowGap: 0.9,
        }}
      >
        {Array.from({
          length: safeFields,
        }).map((_, index) => (
          <Box
            key={index}
            sx={{
              minWidth: 0,
            }}
          >
            <Skeleton variant="text" width="55%" height={14} />
            <Skeleton variant="text" width="85%" height={22} />
          </Box>
        ))}
      </Box>
    </Paper>
  )
}

/**
 * Skeleton preload para tarjetas de tipo mobile.
 * @author isi-template
 */
export const MrtMobileCardSkeleton = memo(MrtMobileCardSkeletonComponent)

/**
 * Skeleton generico para mobiles
 * @author isi-template
 */
export default MrtMobileCardSkeleton
